
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison/listing/[listingSlug]",
      function () {
        return require("private-next-pages/vpnpricecomparison/listing/[listingSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vpnpricecomparison/listing/[listingSlug]"])
      });
    }
  